export const getIsFaireDirectCreditPercentageBased = ({
  amountBps,
  originalAmountBps,
}: {
  amountBps: number | undefined;
  originalAmountBps: number | undefined;
}) => {
  const hasAmountBps = !!amountBps && amountBps > 0;
  const hasOriginalAmountBps = !!originalAmountBps && originalAmountBps > 0;
  return hasAmountBps || hasOriginalAmountBps;
};
